import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_2 = { class: "text-gray-500 font-semibold md:w-36" }
const _hoisted_3 = { class: "flex-1" }

import { PropType } from 'vue'

export interface KeyValuePair {
  key: string
  value: string
}


const __default__ = {
  name: 'BlockKeyValuePairList'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  items: {
    type: Array as PropType<Array<KeyValuePair>>,
    default: () => []
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (__props.items.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.filter(item => !!item.value), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key,
            class: "md:flex md:space-x-3 items-center"
          }, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(item.key), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(item.value), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})